//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import // XButton,
// XInput,
  "vux";
import {mapState} from "vuex";
import {Toast, Dialog} from "vant";
import {service, nativeApi} from "@/common/index";
import {fetch} from "@/page/index";
import VueFileUpload from "vue-file-upload";
import SrmCommonUtils from "@/utils/SrmCommonUtils"

export default {
  data() {
    return {
      searchValue: "",
      quotes: [],
      activeFujian: [""],

      /** 拒绝 popup */
      rejectReason: "",
      showRejectDialog: false,
      rejectIndex: -1,

      /** 刷新用变量 */
      pageIndex: 1,
      pageRows: 10,
      refreshing: true,
      finished: false,
      loading: false,
    };
  },
  components: {
    VueFileUpload,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
    }),
  },
  created() {
    this.requestQuotes();
  },
  activated: function () {
  },
  methods: {
    //搜索 输入
    onInput() {
      this.quotes.splice(0, this.quotes.length); //清空数据
      this.onRefresh(); //重新请求
    },
    onRefresh() {
      //状态设置
      this.refreshing = true;
      this.loading = false;
      this.finished = false;
      //页数设置
      this.pageIndex = 1;
      this.onLoad();
    },
    onLoad() {
      this.requestQuotes();
    },
    requestQuotes() {
      fetch
        .listByPageForBidToMobile({
          lan: this.languageCode,
          pageIndex: this.pageIndex, //页数
          pageRows: this.pageRows,
          biddingName: this.searchValue,
          auctionResult:'FRA_AGREEMENT,INQUIRY_PRICE'
        })
        .then((res) => {
          console.log(res);
          //状态设置
          this.refreshing = false;
          this.loading = false;
          if (res.status === "S") {
            if (res.code === "S") {
              //清楚最后多余的数据
              const curPageIndex = res.page.curIndex; //页数
              const curIndex = (curPageIndex - 1) * this.pageRows; //index
              const lastLength = this.quotes.length - curIndex; //剩余长度
              this.quotes.splice(curIndex, lastLength);

              this.quotes = this.quotes.concat(res.data); //拼接数据
              if (res.data.length >= this.pageRows) {
                this.pageIndex = res.page.nextIndex; //更新页数
              } else {
                //数据length不足row，没有更多数据，不继续往后加载
                this.finished = true;
              }
              res.data.forEach((quote, index) => {
                const resIndex = (this.pageIndex - 2) * this.pageRows + index;
                this.initFilds(quote, resIndex);
              });
            }
          }
        });
    },
    showResponseDialog(auction) {
      Dialog.confirm({
        message: "是否确认参与?",
      })
        .then(() => {
          fetch
            .doAnswerForSupp({
              lan: this.languageCode,
              supplierId: this.userInfo.supplierId,
              auctionNum: auction.auctionNum,
              auctionHeaderId: auction.auctionHeaderId,
              invitingBidWay: auction.invitingBidWay,
            })
            .then((res) => {
              console.log(res);
              if (res.status === "S") {
                if (res.code === "S") {
                  this.mobileSaveSupplierReply(auction.srmSfdBiddingSupplierVO);
                }
              }
            });
        })
        .catch(() => {});
    },
    join(quote) {
      let params = JSON.parse(JSON.stringify(quote.srmSfdBiddingSupplierVO));
      params.lan = this.languageCode;
      params.replyStatus = "ANSWER";
      //1、是否需要附件
      if (quote.infoCheckFlag == "Y") {
        //要添加
        //2、有无附件
        if (
          quote.srmSfdBiddingSupplierVO.infoCheckFileIds == null ||
          quote.srmSfdBiddingSupplierVO.infoCheckFileIds == ""
        ) {
          //无附件
          Toast("请先上传信息核查附件");
          return;
        } else {
          //有附件
          params["infoCheckFileIds"] =
            quote.srmSfdBiddingSupplierVO.infoCheckFileIds;
        }
      } else {
        //无需添加
      }
      //3、发起参与请求
      Dialog.confirm({
        message: "是否确认参与",
      })
        .then(() => {
          this.mobileSaveSupplierReply(params);
        })
        .catch(() => {
        });
    },
    reject(quote) {
      let params = JSON.parse(JSON.stringify(quote.srmSfdBiddingSupplierVO));
      params.lan = this.languageCode;
      params.replyStatus = "REJECT";
      params.refuseReason = this.rejectReason;
      //发起拒绝请求
      this.mobileSaveSupplierReply(params);
    },
    showRejectDialg(index) {
      this.showRejectDialog = true;
      this.rejectIndex = index;
    },
    onConfirmReject() {
      if (this.rejectReason == "") {
        Toast("拒绝原因不能为空");
        return;
      }
      const auction = this.quotes[this.rejectIndex];
      fetch
        .doRefuseForSupp({
          lan: this.languageCode,
          supplierId: this.userInfo.supplierId,
          auctionNum: auction.auctionNum,
          auctionHeaderId: auction.auctionHeaderId,
          invitingBidWay: auction.invitingBidWay,
          refusalCause: this.rejectReason,
        })
        .then((res) => {
          if (res.status === "S") {
            if (res.code === "S") {
              this.onClickQuote(auction);
            }
          }
        });

      this.rejectIndex = -1;
    },
    onCancelReject() {
      this.rejectIndex = -1;
    },
    offer(quote) {
      //投标(创建报价单)
      fetch.bidHeaderRestful_listByPage(
        {auctionHeaderId: quote.auctionHeaderId}
      ).then(res => {
        this.$set(quote, "bidRounds", res.count);
      fetch
        .bidHeaderRestful_doCreateBid({
          lan: this.languageCode,
          auctionHeaderId: quote.auctionHeaderId,
          respondType: "NORMAL_QUOTATION",
          bidRounds:quote.bidRounds,
          ipAddress: this.userInfo.clientIpAddress,
          bidType: "NORMAL_QUOTATION"
        })
        .then((res) => {
          if (res.status === "S") {
            if (res.code === "S") {
              const headerId = res.data.bidHeaderId; //供应商报价id
              quote.bidHeaderId = headerId;
              this.onClickQuote(quote);
            }
          }
        });
      })
    },
    onClickQuote(quote) {
      if (quote.bidHeaderId == null) {
        Toast("请先创建报价单");
        return;
      }
      this.$router.push({
        path: "/Quote",
        query: {
          bidHeaderId: quote.bidHeaderId,
        },
      });
    },
    //文件选择后触发，一次只选择一个文件
    afterRead(file) {
      console.log(file);

      const index = this.quotes.findIndex((item) => {
        if (item.fileList == null) return false;
        const index = item.fileList.findIndex((file) => {
          return file.status == "" || file.status == null;
        });
        return index != -1;
      });
      const quote = this.quotes[index];

      if (!quote || !quote.fileList) return;
      file.status = "uploading"; //上传中。。。
      //上传文件
      fetch
        .fileUpload({
          files: file.file,
        })
        .then((res) => {
          if (res.status === "S" && res.code === "S") {
            //上传完成
            const fujian = res.data[0];
            file.status = "done"; //上传完成
            file.fileId = fujian.id; //记录后台返回的文件Id

            //更新附件ids参数
            this.updateIds(quote);
            console.log(quote);
            this.quotes.splice(index, 1, quote);
          } else {
            //上传失败，设置状态"上传失败"
            file.status = "failed";
          }
        });
      return;
    },
    afterDelete(quote) {
      if (!quote || !quote.fileList) return;
      this.updateIds(quote);
    },
    //更新附件ids参数
    updateIds(quote) {
      if (!quote || !quote.fileList) return;
      const ids = quote.fileList
        .filter((file) => {
          return file.fileId != null && file.fileId != ""; //筛选有id的文件，即已上传成功的文件
        })
        .map((item) => {
          return item.fileId; //取id值
        })
        .toString(); //转字符串
      //更新到quote
      quote.srmSfdBiddingSupplierVO.infoCheckFileIds = ids;
    },
    //报价参与或拒绝
    mobileSaveSupplierReply(params) {
      fetch.mobileSaveSupplierReply(params).then((res) => {
        if (res.status === "S" && res.code === "S") {
          const index = this.quotes.findIndex((item) => {
            return item.biddingCode == res.data.biddingCode;
          });
          if (index == -1) return;
          this.quotes[index] = res.data;
          this.requestQuotes();
        }
      });
    },
    initFilds(quote, index) {
      if (!quote.srmSfdBiddingSupplierVO) return;
      const ids = JSON.parse(
        JSON.stringify(quote.srmSfdBiddingSupplierVO.infoCheckFileIds)
      );
      if (ids == null || ids == "") return;
      // const ids = "5290,5319"
      fetch
        .listBaseFile({
          lan: this.languageCode,
          ids: ids,
        })
        .then((res) => {
          if (res.status === "S" && res.code === "S") {
            quote.fileList = res.data.map((fujian) => {
              return {
                status: "done",
                file: {
                  name: fujian.originalFileName,
                },
                path: fujian.filePath,
                fileId: fujian.id,
                download: true,
              };
            });
            this.quotes.splice(index, 1, quote);
          }
        });
    },
    //下载文件
    download(file) {
      console.log(file);
      fetch
        .getFileUrl({
          id: file.fileId,
        })
        .then((res) => {
          if (res.status === "S" && res.code === "S") {
            Dialog.confirm({
              title: "附件下载",
              message: "是否确认下载附件?",
            })
              .then(() => {
                window.location.href = res.data;
              })
              .catch(() => {
              });
          }
        });
    },
    /**取快码信息*/
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    },
    //删除文件
    deleteFujian(quote, file, index) {
      Dialog.confirm({
        title: "附件删除",
        message: "是否确认删除附件?",
      })
        .then(() => {
          const srcIndex = quote.fileList.findIndex((item) => {
            return (item.fileId = file.fileId);
          });
          quote.fileList.splice(srcIndex, 1);
          quote.srmSfdBiddingSupplierVO.infoCheckFileIds = quote.fileList
            .map((item) => {
              return item.fileId;
            })
            .toString();
          console.log(quote);
          this.quotes.splice(index, 1, quote);
        })
        .catch(() => {
        });
    },
  },
  watch: {},
  mounted() {
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/quote/quoteList.vue